<template>
  <el-container class="app-main">
    <el-row class="home-main">
      <el-col :span="20">
        <el-main>
          <div ref="scrollItem" class="component-info" v-for="(item, index) in myData" :key="index + '-cmp'">
            <div v-if="item.name=='常用工具'">
              <el-card>
                <div slot="header" class="clearfix">
                  <span>{{item.name}}</span>
                  <span>
                    <el-button style="float: right; padding: 3px 0 0 10px" @click="startAdd();" v-if="!openEdit" type="text"
                      icon="el-icon-edit">编辑</el-button>
                    <el-button style="float: right; padding: 3px 0 0 10px" @click="confirmAdd();" v-if="openEdit" type="text"
                      icon="el-icon-check">保存</el-button>
                    <el-button style="float: right; padding: 3px 0 0 10px" @click="cancelAdd();" v-if="openEdit" type="text"
                      icon="el-icon-close">取消</el-button>
                  </span>
                </div>

                <el-row :gutter="0">
                  <draggable :group="item.name" :disabled="!openEdit" v-model="item.arrayList" @start="drag=true" @end="drag=false"
                    ghostClass="drag-ghost" chosenClass="drag-chosen" animation="500">
                    <div v-if="element.inUse" :class="['drag-item-disabled', openEdit ? 'drag-item' : '']" v-for="element in item.arrayList"
                      :key="element.id">
                      <i v-if="(openEdit)&&element.inUse" class="el-icon-remove el-icon-class" @click="beAddOrDel(element.pName,element.id,false)"></i>
                      <div :class="['home-card', openEdit ? 'drag-zy' : '']">
                        <img class="img" :alt="element.resoName" type="image" :src="element.resoIcon" :onerror="defaultImg" />
                        <p class="text">{{element.resoName}}</p>
                        <a class="link" :title="element.resoDesc" :href="element.resoPath" target="_blank"></a>
                      </div>
                    </div>
                  </draggable>
                  <!-- <component :is="item.component" :name="item.name" :group="item.name" :disabled="item.disabled"
                  :arrayList="item.arrayList"></component> -->
                </el-row>
              </el-card>
            </div>

            <div v-else>
              <el-card>
                <div slot="header" class="clearfix">
                  <span>{{item.name}}</span>
                </div>

                <el-row :gutter="10">
                  <el-col :span="6" v-for="(element, index) in item.arrayList" :key="index">
                    <div class="home-grid">
                      <div class="home-name">
                        <img class="home-icon" :alt="element.resoName" type="image" :src="element.resoIcon" :onerror="defaultImg" />
                        {{element.resoName}}
                      </div>
                      <div class="home-content">
                        <div class="home-desc" :title="element.resoDesc">{{element.resoDesc}}</div>
                      </div>
                      <a v-if="!openEdit" class="home-link" :title="element.resoDesc" :href="element.resoPath" target="_blank"></a>
                      <i v-if="(openEdit)&&!element.inUse" class="el-icon-circle-plus el-icon-class" @click="beAddOrDel(element.pName,element.id,true)"></i>
                      <!-- <i v-if="(openEdit)&&element.inUse" class="el-icon-remove el-icon-class" @click="beAddOrDel(element.id,false)"></i> -->
                    </div>
                  </el-col>
                  <!-- <component :is="item.component" :name="item.name" :group="item.name" :disabled="item.disabled"
                  :arrayList="item.arrayList"></component> -->
                </el-row>
              </el-card>
            </div>
          </div>
        </el-main>
      </el-col>

      <el-col :span="4" style="position: sticky;top: 80px;">
        <el-aside width="180px" class="slider-menu">
          <div class="slider-menu-item" v-for="(item, index) in myData" :key='index' :style="item.style || {}" :class="{'slider-menu-item-active': current === index}"
            @click="scrollToView(index)">
            <span>{{item.name}}</span>
          </div>
        </el-aside>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
  import {
    fetchHomeData,
    fetchToolSaveData,
    fetchIndexData
  } from '@/api/index';
  import draggable from 'vuedraggable' //引入拖拽组件 vuedraggable
  export default {
    name: "Home",
    components: {
      draggable: draggable,
    },
    props: {
      data: {
        type: [String, Number, Boolean, Object, Array],
        default: () => [{
          name: '常用工具',
          style: {},
          component: "myDraggable",
          arrayList: [{
            id: 0,
            resoName: 'mkdh',
            resoPath: '/home',
            resoIcon: ' ',
            resoDesc: '不是全球最大同性交友网站',
            pid: 1
          }],
          disabled: true
        }]
      }
    },
    data() {
      return {
        defaultImg: 'onerror=null;this.src="' + require('@/assets/svg/icon.svg') + '"', // 空白占位图
        openEdit: false, // 默认不可编辑
        originalData: [],
        // myData: [],
        tempMyData: [],
        tempMySetting: [],
        current: 0,
        msg: 'Welcome to Home!',
        isCollapse: false,
      }
    },
    methods: {
      /**
       ** @param array: 对象数组
       ** @param groupParam: 对象数组中对象的键名
       ** @return result：按键名分组过的对象数组
       */
      arrayGroupBy(array, groupParam) {
        const arr = array;
        const groupedArr = arr.reduce((pre, item) => {
          const groupName = item[groupParam];
          pre[groupName] = [...pre[groupName] || [], item];
          return pre;
        }, {});
        const result = Object.keys(groupedArr).map(key => {
          const obj = {
            name: key,
            arrayList: groupedArr[key]
          };
          return obj;
        });
        return result;
      },
      init() {

        console.info("isLogin", this.isLogin);
        if (this.$store.getters.getHomes.length > 0) {
          console.info("$store.getters.getHomes", this.$store.getters.getHomes);
          return;
        };

        fetchHomeData({
            params: {
              "dictType": "index_resource_type"
            }
          }) // axios 请求在这里
          .then((res) => {
            let result = res.data;
            if (result.success === true) {
              console.log("result:", result);
              // this.$store.commit('getHome', result.data.result);
              let t = result.data.result
              fetchIndexData().then((myRes) => {
                let myResult = myRes.data;
                if (this.isLogin && myResult.success === true && myResult.data.result) {
                  console.info("myResult", myResult);
                  t.unshift(myResult.data.result);
                } else {
                  t.unshift({
                    arrayList: [],
                    name: "常用工具"
                  });
                }
              });
              this.$store.commit('getHome', t);
            };

          })
          .catch((error) => {
            console.log("error:", error);
            // this.error();
          });
      },
      error() {
        this.axios.get('/static/mock/home.json')
          .then((res) => {
            const data = res.data.data;
            const resourceList = [];
            this.originalData = JSON.parse(JSON.stringify(data));

            for (let key in data) {
              resourceList.push(data[key]);
            };

            const obj = {
              name: "常用工具",
              arrayList: this.originalData
            };

            this.myData = this.arrayGroupBy(resourceList, "pName");
            this.myData.unshift(obj);
          });
      },
      // 点击编辑
      startAdd() {
        if (!this.isLogin) {
          this.$alert('请先登录', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              const {
                path
              } = this.$route;

              this.$router.replace({
                path: '/login',
                query: {
                  redirect: path
                }
              })
            }
          });
          return;
        };

        this.openEdit = true;
        let tempData = this.myData;
        this.tempMyData = JSON.parse(JSON.stringify(tempData));
      },
      // 点击加号
      beAddOrDel(pName, id, inUse) {
        let tempData = this.myData;
        for (let item of tempData) {
          if (item.name == pName) {
            for (let key in item.arrayList) {
              if (item.arrayList[key].id == id) {
                item.arrayList[key].inUse = inUse;

                if (inUse) {
                  tempData[0].arrayList.push(item.arrayList[key]);
                } else {
                  for (let myKey in tempData[0].arrayList) {
                    if (tempData[0].arrayList[myKey].id == id) {
                      console.log("beAddOrDel:", myKey);
                      tempData[0].arrayList.splice(myKey, 1);
                    };
                  };
                };
              };
            };
          };
        };
        this.$store.commit('getHome', tempData);
        // this.myData = tempData;
      },
      // 取消编辑
      cancelAdd() {
        this.$confirm('不保存当前操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.openEdit = false;
          this.$store.commit('getHome', this.tempMyData);
          // this.myData = this.tempMyData;
          this.$message({
            type: 'success',
            message: '已取消编辑'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '继续编辑'
          });
        });
      },
      // 保存编辑
      confirmAdd() {
        this.openEdit = false;
        let ids = [];
        const el = this.myData[0].arrayList;
        for (let l of el) {
          if (l.inUse) {
            ids.push(l.id);
          }
        };

        if (this.isLogin) {
          fetchToolSaveData({
              data: {
                "ids": ids
              }
            }) // axios 请求在这里
            .then((res) => {
              let result = res.data;
              console.info(result);
              if (result.success === true) {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
              } else {
                this.$store.commit('getHome', this.tempMyData);
                this.$message({
                  type: 'error',
                  message: result.msg
                });
              };
            })
            .catch((error) => {
              this.$store.commit('getHome', this.tempMyData);
              this.$message({
                type: 'error',
                message: '操作失败'
              });
              console.log("error:", error);
            });
        };
      },
      // 将数组根据条件分组
      getTreeDateByParam(list, param, fun) {
        let data = {};
        if (list && list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            if (param) {
              let res = list[i][param]
            } else if (fun) {
              let res = fun(list[i]);
            }
            if (data[res]) {
              data[res].push(list[i]);
            } else {
              data[res] = [list[i]];
            }
          }
        }
        return data;
      },
      scrollToView(index) {
        let data = this.getScrollItems()
        if (index >= 0 && index < data.length) {
          let item = data[index] || {}
          const scrollTop = this.getScroll(window, true)
          const elOffset = this.getOffset(item)
          let top = elOffset.top - this.getStartTop() - 60;
          window.scrollTo({
            top: top < 0 ? 0 : top,
            behavior: 'smooth'
          })
        }
      },
      handleScroll(e) {
        let data = this.getScrollItems()
        const scrollTop = this.getScroll(window, true)
        let maxTop = -99999
        data.forEach((target, index) => {
          const elOffset = this.getOffset(target)
          let realTop = elOffset.top - this.getStartTop() - scrollTop - 60
          if (realTop <= 0 && maxTop <= realTop) {
            maxTop = realTop
            this.current = index;
          }
        })
      },
      getStartTop() {
        if (this.$refs.sliderMenu) {
          return this.$refs.sliderMenu.offsetTop || 0
        }
        return 0
      },
      getScrollItems() {
        let refs = []
        if (this.$refs.scrollItem && this.$refs.scrollItem.style) {
          refs.push(this.$refs.scrollItem)
        } else if (this.$refs.scrollItem && this.$refs.scrollItem.length) {
          refs = this.$refs.scrollItem
        }
        return refs
      },
      getScroll(target, top) {
        const prop = top ? 'pageYOffset' : 'pageXOffset'
        const method = top ? 'scrollTop' : 'scrollLeft'
        let ret = target[prop]
        if (typeof ret !== 'number') {
          ret = window.document.documentElement[method]
        }
        return ret
      },
      getOffset(element) {
        const rect = element.getBoundingClientRect()
        const scrollTop = this.getScroll(window, true)
        const scrollLeft = this.getScroll(window)

        const docEl = window.document.body
        const clientTop = docEl.clientTop || 0
        const clientLeft = docEl.clientLeft || 0
        let height = rect.bottom - rect.top
        if (height === 0 && element.parentNode) {
          let parentRect = element.parentNode.getBoundingClientRect()
          height = parentRect ? parentRect.height || 0 : 0
        }
        return {
          top: rect.top + scrollTop - clientTop,
          left: rect.left + scrollLeft - clientLeft,
          height: height,
          width: rect.right - rect.left
        }
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      }
    },
    watch: {
      tempMyData: function(newName, oldName) {
        console.info("newName:", newName);
        console.info("oldName:", oldName);
        console.info("\n");
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll, false);
      window.addEventListener('resize', this.handleScroll, false);
    },
    created() {
      this.init()
    },
    computed: {
      myData() {
        return this.$store.getters.getHomes;
      },
      isLogin() {
        return this.$store.getters.isLogin;
      },
      getUserToken() {
        return this.$store.getters.getUserToken;
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll, false);
      window.removeEventListener('resize', this.handleScroll, false);
    }
  }
</script>

<style scoped lang="less">
  .el-header,
  .el-footer {
    // background-color: #B3C0D1;
    // color: #333;
  }

  .el-aside {
    // background-color: #D3DCE6;
    // color: #333;
    // max-height: calc(100vh - 100px);
    padding-left: 20px;
  }

  .el-main {
    // background-color: #E9EEF3;
    // color: #333;
    padding: 0;
  }

  .app-main {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    max-width: 1200px;

    .home-grid {
      position: relative;
      padding: 15px 10px 10px 20px;
      margin: 4px 0;
      border-radius: 4px;
      cursor: pointer;

      .home-name {
        height: 34px;
        line-height: 34px;
        font-weight: bold;
        font-size: 14px;
        color: #444;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: flex;
      }

      .home-icon {
        width: 34px;
        height: 34px;
        min-width: 34px;
        min-height: 34px;
        border-radius: 50px;
        border: 1px solid transparent;
        margin-right: 12px;
      }

      .home-content {
        position: relative;
      }

      .home-desc {
        font-size: 12px;
        color: #585858;
        text-align: justify;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        min-height: 32px;
        margin-top: 5px;
        line-height: 16px;
      }

      .home-link {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }
    }

    .home-grid:hover {
      background-color: #DBDBDB;
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
      transform: translateY(-6px);
      transition: all 0.3s ease-in-out;

      .home-name {
        color: #409EFF;
      }

      .home-content {

        .home-icon {
          // border: 1px solid red;
        }

        .home-desc {
          color: #409EFF;
        }
      }
    }

    .home-main {
      width: 100%;
      height: auto;
      min-height: 100vh;

      .el-card {
        margin-bottom: 20px;
      }

      .slider-menu {
        // position: fixed;
        // overflow: auto;
        // color: #000;
        // height: auto;
        // top: auto;
        // z-index: 2;
      }

      .slider-menu-item {
        position: relative;
        display: block;
        border-left: 2px solid #e8eaed;
        padding: 10px 20px;
        margin: auto;
        line-height: 24px;
        color: inherit;
        cursor: pointer;
      }

      .slider-menu-item-active,
      .slider-menu-item:hover {
        color: rgb(64, 158, 255);
        // border-left: 2px solid rgb(64, 158, 255);
      }

      .slider-menu-item-active {
        border-left: 2px solid rgb(64, 158, 255);
      }

      .drag-item-disabled {
        position: relative;
        display: inline-block;
      }

      /*被拖拽对象的样式*/
      .drag-item {
        background-color: #fdfdfd;
        cursor: move;
      }

      .drag-item:hover {
        background-color: #f1f1f1;
      }

      .drag-zy {
        animation: zy linear .3s infinite;
      }

      @keyframes zy {
        0% {
          transform: rotate(2deg);
        }

        25% {
          transform: rotate(0deg);
        }

        50% {
          transform: rotate(-2deg);
        }

        75% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(2deg);
        }
      }

      /*选中样式*/
      .drag-chosen {
        background-color: #000 !important;
        background: rgba(238, 238, 238, 1) !important;
      }

      /*位符样式*/
      .drag-ghost {
        background-color: #fff !important;
        border: 1px dashed rgba(170, 170, 170, 1);
      }

      .el-icon-class {
        position: absolute;
        right: 0;
        top: 0;
        color: rgb(64, 158, 255);
        cursor: pointer;
      }

      .el-icon-remove.el-icon-class {
        color: red;
      }

      .home-card {
        position: relative;
        margin: 10px;
        height: 100px;
        width: 100px;
        text-align: center;
        border-radius: 10px;
        font-size: 14px;
        border-color: transparent;
        background-color: transparent;
        background: rgba(170, 170, 170, .4);
      }

      .home-card:hover {
        color: rgb(64, 158, 255);
        // background: rgba(170, 170, 170, .4);
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
      }

      .home-card .img {
        width: 40px;
        height: 40px;
        margin: 15px auto 0;
        border-radius: 10px;
      }

      .home-card .text {
        /* line-height: 1; */
        margin: 5px 8px 0;
        /*溢出隐藏*/
        overflow: hidden;
        /*以省略号...显示*/
        text-overflow: ellipsis;
        /*强制不换行*/
        white-space: nowrap;
      }

      .home-card .link {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }

      .drag-item .home-card .link {
        cursor: move;
      }
    }
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue